import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconsModule } from "../icons/icons.module";
import { UpcomingLaunchWidgetComponentModule } from "../upcoming-launch-widget/upcoming-launch-widget.component.module";
import { HeaderComponent } from "./header.component";

@NgModule({
  imports: [CommonModule, IconsModule, RouterModule, UpcomingLaunchWidgetComponentModule],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
})
export class HeaderComponentModule {}
